export default "__VITE_ASSET__jlqw3jJj__"